import script from "./SearchFacetColorsSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchFacetColorsSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./SearchFacetColorsSkeleton.vue?vue&type=style&index=0&id=540d665a&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540d665a"]])

export default __exports__